"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeeRate = exports.useFeeRateLoading = void 0;
const react_1 = require("react");
const FutureAPI_1 = require("../apis/FutureAPI");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const DefaultData = {
    rate: {
        makerFeeRate: 0.0002,
        takerFeeRate: 0.0005,
    },
    loading: true,
};
const useFeeRateLoading = (base, quote) => {
    const [data, setData] = (0, react_1.useState)(DefaultData);
    (0, react_1.useEffect)(() => {
        if (!base || !quote) {
            return;
        }
        setData((pre) => {
            return Object.assign(Object.assign({}, pre), { loading: true });
        });
        const sub = (0, rxjs_1.timer)(0, 1000 * 60 * 60)
            .pipe((0, operators_1.mergeMap)(() => {
            return (0, FutureAPI_1.queryFutureFeeRate)(base, quote);
        }))
            .subscribe({
            next: (feeRate) => {
                setData({
                    rate: {
                        makerFeeRate: feeRate.maker_fee_rate,
                        takerFeeRate: feeRate.taker_fee_rate,
                    },
                    loading: false,
                });
            },
            error: (err) => {
                setData((pre) => {
                    return Object.assign(Object.assign({}, pre), { loading: false });
                });
                console.log(err);
            },
        });
        return () => sub.unsubscribe();
    }, [base, quote]);
    return { feeRate: data.rate, loading: data.loading };
};
exports.useFeeRateLoading = useFeeRateLoading;
const useFeeRate = (base, quote) => {
    const { feeRate } = (0, exports.useFeeRateLoading)(base, quote);
    return feeRate;
};
exports.useFeeRate = useFeeRate;
